import ThemeProvider from '@voltmoney/theme';
import React, { memo, useEffect, useState, } from 'react';
import { Animated, Dimensions, PanResponder, SafeAreaView, ScrollView, StyleSheet, TouchableOpacity, View, } from 'react-native';
import { BorderRadiusTokens, ColorTokens, IconTokens, } from '@voltmoney/schema';
import { Icon } from '../icon/Icon';
/**
 * Raw Component with Derived props + Theme
 */
const theme = ThemeProvider.getTheme();
const colorMapping = theme.colors;
const borderRadiusMapping = theme.borderRadius;
const BottomSheetWebBase = ({ children, widgetItems, renderItem, padding = {
    top: 0,
    bottom: 0,
    left: 16,
    right: 16,
    vertical: 0,
    horizontal: 16,
}, initialOffset = 0.25, finalOffSet = 0.8, metaData, headerChildren, widgetHeaderItems, }) => {
    const scrollValue = 5;
    const [scrollOffSetY, setScrollOffSet] = useState(0);
    const [open, setOpen] = useState(false);
    const windowX = Dimensions.get('window');
    let ANIMATED = {
        OPEN_HEIGHT: Math.round(windowX.height * finalOffSet),
        CLOSE_HEIGHT: Math.round(windowX.height * initialOffset),
    };
    useEffect(() => {
        if (open === true) {
            animateMove(ANIMATED.OPEN_HEIGHT);
        }
        else {
            animateMove(ANIMATED.CLOSE_HEIGHT);
        }
    }, [open]);
    const STARTING_POSITION = ANIMATED.CLOSE_HEIGHT;
    const animatedPosition = new Animated.Value(STARTING_POSITION);
    const animateMove = (toValue) => {
        console.log('animateMove: ', toValue);
        if (toValue) {
            Animated.timing(animatedPosition, {
                toValue,
                duration: 250,
                useNativeDriver: false,
            }).start();
        }
    };
    const movementValue = (gestureState) => {
        // //on swipe down
        // if( gestureState.dy >= scrollValue && open === true && scrollOffSetY === 0 ){
        //     return ANIMATED.CLOSE_HEIGHT;
        // }
        // on swipe up
        if (gestureState.dy <= -scrollValue) {
            return ANIMATED.OPEN_HEIGHT;
        }
    };
    const onMoveShouldSetPanResponder = (_, gestureState) => {
        return isSwipeUp(gestureState);
    };
    const onPanResponderMove = (_, gestureState) => {
        console.log('onPanResponderMove');
        if (isSwipeUp(gestureState) && open === false) {
            openModal();
        }
    };
    const isSwipeUp = (gestureState) => {
        return gestureState.dy <= -scrollValue;
    };
    const isSwipeDown = (gestureState) => {
        return gestureState.dy >= scrollValue;
    };
    const closeModal = async () => {
        await setOpen(false);
    };
    const openModal = async () => {
        await setOpen(true);
    };
    const onPanResponderRelease = (_, gestureState) => {
        const toValue = movementValue(gestureState);
        if (isSwipeUp(gestureState) && open === false) {
            openModal();
        }
    };
    const handleScroll = async (e) => {
        await setScrollOffSet(e.nativeEvent.contentOffset.y);
    };
    const handleClose = () => {
        closeModal();
    };
    const panGesture = PanResponder.create({
        onPanResponderMove,
        onPanResponderRelease,
        onMoveShouldSetPanResponder,
        onPanResponderTerminationRequest: (evt, gestureState) => true,
        onStartShouldSetPanResponderCapture: onMoveShouldSetPanResponder,
    });
    const headerContent = (React.createElement(React.Fragment, null,
        headerChildren,
        renderItem &&
            widgetHeaderItems &&
            widgetHeaderItems.map(renderItem)));
    const content = (React.createElement(React.Fragment, null,
        children,
        renderItem &&
            widgetItems &&
            widgetItems.map(renderItem)));
    const styles = StyleSheet.create({
        container: {
            width: '100%',
            borderTopLeftRadius: borderRadiusMapping[BorderRadiusTokens.BR3],
            borderTopRightRadius: borderRadiusMapping[BorderRadiusTokens.BR3],
            backgroundColor: colorMapping[ColorTokens.White],
            borderWidth: 1,
            borderColor: colorMapping[ColorTokens.Grey_Milk_1],
            shadowColor: colorMapping[ColorTokens.Grey_Milk_1],
            shadowOffset: {
                width: 0,
                height: 3,
            },
            shadowOpacity: 0.27,
            shadowRadius: 4.65,
            elevation: 6,
            paddingLeft: padding.left ? padding.left : 16,
            paddingRight: padding.right
                ? padding.right
                : 16,
            paddingTop: padding.top ? padding.top : 0,
            paddingBottom: padding.bottom
                ? padding.bottom
                : 0,
            paddingVertical: padding.vertical
                ? padding.vertical
                : 0,
            paddingHorizontal: padding.horizontal
                ? padding.horizontal
                : 16,
        },
        gestureArea: {
            width: '100%',
            height: 35,
            justifyContent: 'center',
            alignItems: 'center',
        },
        pullItem: {
            width: 48,
            height: 5,
            position: 'relative',
            top: 2,
            borderRadius: borderRadiusMapping[BorderRadiusTokens.BR3],
            backgroundColor: colorMapping[ColorTokens.Grey_Milk_1],
        },
        pullItemWithOutButton: {
            width: 48,
            height: 5,
            position: 'relative',
            bottom: 8,
            borderRadius: borderRadiusMapping[BorderRadiusTokens.BR3],
            backgroundColor: colorMapping[ColorTokens.Grey_Milk_1],
        },
        closeItem: {
            position: 'relative',
            left: '48%',
            width: 25,
            height: 25,
            display: open ? 'flex' : 'none',
            justifyContent: 'center',
            alignItems: 'center',
            borderRadius: borderRadiusMapping[BorderRadiusTokens.BR5],
            backgroundColor: colorMapping[ColorTokens.Grey_Milk_1],
        },
        content: {
            flex: 1,
        },
        headerContent: {},
    });
    return (React.createElement(Animated.View, { style: [
            styles.container,
            { height: animatedPosition },
        ], ...panGesture.panHandlers },
        React.createElement(View, { style: styles.gestureArea },
            React.createElement(View, { style: open
                    ? styles.pullItem
                    : styles.pullItemWithOutButton }),
            React.createElement(TouchableOpacity, { style: styles.closeItem, onPress: handleClose },
                React.createElement(Icon, { name: IconTokens.Cross, color: ColorTokens.Grey_Night }))),
        React.createElement(SafeAreaView, { style: styles.content },
            React.createElement(View, { style: styles.headerContent }, headerContent),
            React.createElement(ScrollView, { scrollEnabled: open, onScroll: handleScroll, showsVerticalScrollIndicator: false, scrollEventThrottle: 16 }, content))));
};
export default memo(BottomSheetWebBase);
export { BottomSheetWebBase };
